import { Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { useOptionalIperiaStatus } from '../../hooks/useIperiaStatus'
import { hasAmSigned } from '../../utils/iperiaNavigation'

/**
 * Accès discret au hub du lot une fois que le dossier courant n'a plus d'action pour l'AM.
 *
 * Pendant le parcours, on ne le montre pas : ça détournerait de l'étape en cours. Dès que le
 * bulletin est signé, le hub est le seul endroit où revoir les autres formations du lot.
 */
const IperiaAllRegistrationsLink = () => {
  const status = useOptionalIperiaStatus()?.status
  const groupId = status?.group?.global_id

  if (!status || !groupId || !hasAmSigned(status)) return null

  return (
    <Link
      component={RouterLink}
      to={`/groupe/${groupId}`}
      variant="body2"
      underline="always"
      sx={{ textDecoration: 'underline' }}
    >
      Toutes mes inscriptions
    </Link>
  )
}

export default IperiaAllRegistrationsLink
